import type { GameRowValue } from '../backend.d'
import { Component } from 'solid-js'

interface Props {
  row: GameRowValue,
  width: number,
  height: number,
  minWidth?: number,
  minHeight?: number,
}

/**
 * @deprecated
 */
const GameShowCanvas: Component<Props> = () => {
  throw new Error('Deprecated: GameShowCanvas')
}

export default GameShowCanvas